import { render, staticRenderFns } from "./VATyear.vue?vue&type=template&id=84a58bee&scoped=true&"
import script from "./VATyear.vue?vue&type=script&lang=js&"
export * from "./VATyear.vue?vue&type=script&lang=js&"
import style0 from "./VATyear.vue?vue&type=style&index=0&id=84a58bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a58bee",
  null
  
)

export default component.exports